module.exports = require("secure-random");